export default __webpack_public_path__ + "static/Whatsapp-b411946cd3bfd059eebb0c4f5930754f.png";